import "./HowItWorks.css";

export const HowItWorks = () => {
  return (
    <div id="how-it-works" className="howItWorks" >
        <div className="howItWorksTitle" >
        How It Works
        </div>
        <div className="howItWorksSteps">
            <div className="howItWorksStep">
                <div className="howItWorksStepImg">
                    <img alt="Step 1" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/How_it_Works/step1.svg"} style={{maxWidth: "80%", height: "auto", marginTop: "36px"}}/>
                </div>
                <div className="howItWorksStepTitle">
                STEP ONE
                </div>
                <div className="howItWorksStepText">
                Every week our tasting panel chooses a phenomenal new coffee from the hundreds they taste.
                </div>
            </div>

            <div className="howItWorksStep">
                <div className="howItWorksStepImg">
                    <img alt="Step 2" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/How_it_Works/step2.svg"} style={{maxWidth: "100%", height: "auto"}}/>
                </div>
                <div className="howItWorksStepTitle">
                STEP TWO
                </div>
                <div className="howItWorksStepText">
                We send you a text about the coffee with a limited time window to buy it.
                </div>
            </div>
            <div className="howItWorksStep">
                <div className="howItWorksStepImg">
                    <img alt="Step 3" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/How_it_Works/step3.svg"} style={{maxWidth: "100%", height: "auto"}}/>
                </div>
                <div className="howItWorksStepTitle">
                STEP THREE
                </div>
                <div className="howItWorksStepText">
                Text us back with how many bags you want.
                </div>
            </div>
            <div className="howItWorksStep">
                <div className="howItWorksStepImg">
                    <img alt="Step 4" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/How_it_Works/step4.svg"} style={{maxWidth: "100%", height: "auto"}}/>
                </div>
                <div className="howItWorksStepTitle">
                STEP FOUR
                </div>
                <div className="howItWorksStepText">
                We mail you the coffee: whole bean, roasted to order, and ready to enjoy all week.
                </div>
            </div>

        </div>
    </div>
  );
}

